export function isCompatibleVersionIdInvalid(
  manifestVersion: string,
  versionFromInput: string
): boolean {
  if (!manifestVersion || !versionFromInput) {
    return false;
  }

  const manifestIdVersion = manifestVersion.trim().split('-')[0];
  const inputIdVersion = versionFromInput.trim().split('-')[0];

  return manifestIdVersion !== inputIdVersion;
}
